import { getAccountId } from '@seek/adv-account-selection';

import { useGetQuestionsLazyQuery } from 'src/graphql/generated';

export const useQuestionsLazyQuery = (questionnaireId: string) => {
  const [getQuestionsQuery] = useGetQuestionsLazyQuery({
    variables: {
      questionnaireId,
      advertiserId: getAccountId() || '',
    },
    fetchPolicy: 'cache-first',
  });

  return [getQuestionsQuery];
};
